import React from 'react'

const DoubleChevronLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.8672 0.5L6.20225 5.26774C5.82381 5.65453 5.82169 6.27218 6.19748 6.66155L10.8672 11.5"
            stroke="currentColor"
            strokeOpacity="0.12"
            strokeLinecap="round"
        />
        <path
            d="M6.34375 0.5L1.6788 5.26774C1.3004 5.65453 1.2983 6.27218 1.674 6.66155L6.34375 11.5"
            stroke="currentColor"
            strokeOpacity="0.12"
            strokeLinecap="round"
        />
    </svg>
)

export default DoubleChevronLeftIcon
